// import React from "react";

// const Gdsbanner = () => {
//   const bannerStyles = {
//     // marginTop:"60px",
//     width: "100%",
//     height: "90vh", 
//     backgroundImage: "url('/image/gds7.jpg')",  
//     backgroundSize: "cover",
//     backgroundPosition: "center center",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     color: "white",
//     position: "relative",
//     overflow: "hidden",
//   };

//   const contentStyles = {
//     maxWidth: "90%",
//     padding: "0 20px",  
//   };

//   const headingStyles = {
//     fontSize: "4rem",  
//     margin: 0,
//     lineHeight: 1.2,
//     fontWeight: "bold",
//   };

//   const paragraphStyles = {
//     fontSize: "1.5rem",  
//     marginTop: "1rem",
//   };

  
//   const mediaQueryStyles = {
//     "@media (max-width: 1200px)": {
//       heading: { fontSize: "3.5rem" },
//       paragraph: { fontSize: "1.3rem" },
//     },
//     "@media (max-width: 768px)": {
//       heading: { fontSize: "2.5rem" },
//       paragraph: { fontSize: "1.2rem" },
//     },
//     "@media (max-width: 480px)": {
//       heading: { fontSize: "2rem" },
//       paragraph: { fontSize: "1rem" },
//     },
//   };

//   return (
//     <div style={bannerStyles}>
//       <div style={contentStyles}>
       
        
//       </div>
//     </div>
//   );
// };

// export default Gdsbanner;


import React from "react";

const Gdsbanner = () => {
  const bannerStyles = {
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/gds7.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  };

  // 🔥 Overlay
  const overlayStyles = {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to right, rgba(0,0,0,0.65), rgba(0,0,0,0.35))",
    zIndex: 1,
  };

  const contentStyles = {
    position: "relative",
    zIndex: 2,
    maxWidth: "900px",
    padding: "0 20px",
    textAlign: "center",
    color: "#fff",
  };

  const headingStyles = {
    fontSize: "4rem",
    fontWeight: "700",
    marginBottom: "15px",
    lineHeight: "1.2",
  };

  const paragraphStyles = {
    fontSize: "1.4rem",
    opacity: 0.9,
    marginBottom: "30px",
  };

  const badgeStyles = {
    display: "inline-block",
    padding: "8px 18px",
    borderRadius: "20px",
    background: "rgba(255,255,255,0.15)",
    backdropFilter: "blur(6px)",
    fontSize: "14px",
    letterSpacing: "1px",
    marginBottom: "20px",
  };

  return (
    <div style={bannerStyles}>
      <div style={overlayStyles}></div>

      {/* <div style={contentStyles}>
        <span style={badgeStyles}>CREATIVE DESIGN STUDIO</span>

        <h1 style={headingStyles}>
          Graphic & UI/UX <br /> Designer
        </h1>

        <p style={paragraphStyles}>
          Crafting modern visuals, creative branding, and engaging digital
          experiences that make your brand stand out.
        </p>
      </div> */}
    </div>
  );
};

export default Gdsbanner;

